import styled from '@emotion/styled';

import IconCheckCircle from 'components/icons/checkCircle';
import IconCross from 'components/icons/cross';

export const ItemName = styled.div(() => ({
  fontSize: 14,
  fontWeight: 400,
  minWidth: 150,
}));

export const StyledItemName = styled(ItemName)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 6,
}));

export const CheckIcon = styled(IconCheckCircle)((props) => ({
  overflow: 'visible',
  color: props.theme.colors.secondary,
}));

export const Container = styled.div((_) => ({
  display: 'flex',
  padding: '8px 16px',
  justifyContent: 'space-between',
  alignItems: 'center',
  alignSelf: 'stretch',
}));

export const Item = styled.div((_) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 5,
}));

export const ItemValue = styled.div((props) => ({
  color: props.theme.colors.inactive,
  fontSize: 14,
  fontWeight: 400,
}));

export const Id = styled(ItemValue)((props) => ({
  fontFamily: props.theme.fonts.secondary,
}));

export const SectionWrapper = styled.div(() => ({
  display: 'flex',
  padding: 10,
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: 15,
  alignSelf: 'stretch',
}));

export const FailedIcon = styled(IconCross)((props) => ({
  path: {
    fill: props.theme.colors.error.main,
  },
}));
